import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootPrintPortalManager.frontend.types'
import { $frontendTypes as $types} from './FootPrintPortalManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';



interface IFootPrintPortalManager_shipping_order_tasks_gridComponentEntity {
Id?: number, ActualPackagedAmount?: number, ChainHead?: number, CompletedDateTime?: string, CreatedSysDateTime?: string, ExpectedPackagedAmount?: number, ModifiedSysUser?: string, Notes?: string, SerialNumberId?: number, ActualPackagedPack?: { ShortName?: string }, ExpectedPackagedPack?: { ShortName?: string }, Lot?: { Id?: number, LookupCode?: string, Material?: { ProjectId?: number, Project?: { Id?: number, LookupCode?: string } } }, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { Id?: number, LookupCode?: string } }, Project?: { Id?: number, LookupCode?: string }, OperationCode?: { Name?: string }, Status?: { Name?: string }, ActualSourceLicensePlate?: { Id?: number, LookupCode?: string }, ActualSourceLocation?: { Id?: number, Name?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string }, ActualTargetLocation?: { Id?: number, Name?: string }, ExpectedSourceLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedSourceLocation?: { Id?: number, Name?: string }, ExpectedTargetLicensePlate?: { Id?: number, LookupCode?: string }, ExpectedTargetLocation?: { Id?: number, Name?: string }, Warehouse?: { Name?: string }, Order?: { LookupCode?: string, OwnerReference?: string, VendorReference?: string }, SerialNumber?: { LookupCode?: string }}

interface IFootPrintPortalManager_shipping_order_tasks_gridComponentInParams {
  orderId?: number, shipmentId?: number}


class FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_shipping_order_tasks_gridComponent;
  entity: IFootPrintPortalManager_shipping_order_tasks_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Id: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    warehouse: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    operation_code: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    status: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    material_lookupcode: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    lot: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    serialnumber: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    actual_packaged_amount: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    actual_target_licenseplate: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    expected_packaged_amount: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    created_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    completed_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    notes: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
private logger: CleanupLoggerService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, entity: IFootPrintPortalManager_shipping_order_tasks_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, entity?: IFootPrintPortalManager_shipping_order_tasks_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      orderId:  $grid.inParams.orderId ,
      fullTextSearch:  $grid.fullTextSearch ,
      shipmentId:  $grid.inParams.shipmentId ,
    };
    const data = await this.datasources.FootPrintPortalManager.ds_shipping_orders_tasks_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse.Name;
    (this.cells.operation_code.displayControl as TextModel).text = $row.entity.OperationCode?.Name;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.material_lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.serialnumber.displayControl as TextModel).text = $row.entity.SerialNumber?.LookupCode;
    (this.cells.actual_packaged_amount.displayControl as TextModel).text = $utils.isDefined($row.entity.ActualPackagedAmount) ? $row.entity.ActualPackagedAmount?.toString() + ' ' + $row.entity.ActualPackagedPack?.ShortName : '';
    (this.cells.actual_target_licenseplate.displayControl as TextModel).text = $row.entity.ActualTargetLicensePlate?.LookupCode;
    (this.cells.expected_packaged_amount.displayControl as TextModel).text = $utils.isDefined($row.entity.ExpectedPackagedAmount) ? $row.entity.ExpectedPackagedAmount?.toString() + ' ' + $row.entity.ExpectedPackagedPack?.ShortName : '';
    (this.cells.notes.displayControl as TextModel).text = $row.entity.Notes;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'material_lookupcode' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'serialnumber' : {
        this.on_serialnumber_clicked();
        break;
      }
      case 'actual_target_licenseplate' : {
        this.on_actual_target_lp_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Apply date format
  
  // Set Date/Time Formats
  const format = `${$settings.FootPrintPortalManager.DateFormat}, ${$settings.FootPrintPortalManager.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  
  
  if ($utils.isDefined($row.entity.CreatedSysDateTime) ) {
      $row.cells.created_date.displayControl.text = $utils.date.format($row.entity.CreatedSysDateTime , format);
  }
  
  
  if ($utils.isDefined($row.entity.CompletedDateTime) ) {
      $row.cells.completed_date.displayControl.text =  $utils.date.format($row.entity.CompletedDateTime , format);
  }
  
  
  
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  if (await $operations.FootPrintPortalManager.Disable_Material_Management.isAuthorized()) {
      $shell.FootPrintPortalManager.openInfoDialog('Material management', 'You are not authorized the view and manage the material')
  }
  else {
  
  
  
  
      if ($utils.isDefined($row.entity?.Material?.Id)) {
          $shell.FootPrintPortalManager.opensingle_material_hub({ materialId: $row.entity.Material.Id });
      }
  
  
  }
  
  
  
  
  }
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  if (await $operations.FootPrintPortalManager.Disable_Lot_Management.isAuthorized()) {
      $shell.FootPrintPortalManager.openInfoDialog('Lot management', 'You are not authorized the view and manage the lot')
  }
  else {
  
  
      if ($utils.isDefined($row.entity?.Lot?.Id)) {
          $shell.FootPrintPortalManager.opensingle_lot_hub({ lotId: $row.entity.Lot.Id });
      }
  
  }
  
  
  
  
  }
  on_actual_target_lp_clicked(event = null) {
    return this.on_actual_target_lp_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_actual_target_lp_clickedInternal(
    $row: FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  if (await $operations.FootPrintPortalManager.Disable_Pallet_Management.isAuthorized()) {
      $shell.FootPrintPortalManager.openInfoDialog('Pallet management', 'You are not authorized the view and manage the pallet')
  }
  else {
  
      if ($utils.isDefined($row.entity?.ActualTargetLicensePlate?.Id)) {
          $shell.FootPrintPortalManager.opensingle_pallet_hub({ licenseplateId: $row.entity.ActualTargetLicensePlate.Id });
      }
  
  }
  
  
  
  }
  on_serialnumber_clicked(event = null) {
    return this.on_serialnumber_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_serialnumber_clickedInternal(
    $row: FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel,
  $grid: FootPrintPortalManager_shipping_order_tasks_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($row.entity?.SerialNumberId)) {
      $shell.FootPrintPortalManager.opensingle_serialnumber_hub({ serialnumberId: $row.entity.SerialNumberId });
  }
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootPrintPortalManager-shipping_order_tasks_grid',
  templateUrl: './FootPrintPortalManager.shipping_order_tasks_grid.component.html'
})
export class FootPrintPortalManager_shipping_order_tasks_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_shipping_order_tasks_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_shipping_order_tasks_gridComponentInParams = { orderId: null, shipmentId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'ID', false, false, null),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', false, false, null),       operation_code: new GridHeaderModel(new HeaderStyles(null, null), 'Operation code', false, false, null),       status: new GridHeaderModel(new HeaderStyles(null, null), 'Status', false, false, null),       material_lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Material', false, false, null),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'Lot', false, false, null),       serialnumber: new GridHeaderModel(new HeaderStyles(null, null), 'Serial number', false, false, null),       actual_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'Actual', false, false, null),       actual_target_licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'Actual target pallet', false, false, null),       expected_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'Expected', false, false, null),       created_date: new GridHeaderModel(new HeaderStyles(null, null), 'Created date', false, false, null),       completed_date: new GridHeaderModel(new HeaderStyles(null, null), 'Completed date', false, false, null),       notes: new GridHeaderModel(new HeaderStyles(null, null), 'Notes', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('orderId') set $inParams_orderId(value: any) {
    this.inParams['orderId'] = value;
  }
  get $inParams_orderId(): any {
    return this.inParams['orderId'] ;
  }
  @Input('shipmentId') set $inParams_shipmentId(value: any) {
    this.inParams['shipmentId'] = value;
  }
  get $inParams_shipmentId(): any {
    return this.inParams['shipmentId'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    private logger: CleanupLoggerService,
    ) {
    super();
    this.title = 'Shipping order tasks';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;

    this.pageSize = 50;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      orderId:  $grid.inParams.orderId ,
      fullTextSearch:  $grid.fullTextSearch ,
      shipmentId:  $grid.inParams.shipmentId ,
    };
    try {
    const data = await this.datasources.FootPrintPortalManager.ds_shipping_orders_tasks_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_shipping_order_tasks_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations,
          this.logger);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
